import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { googleWorkspaceWeb } from '../web-manifest.js';
import { GoogleIcon } from './GoogleIcon.js';

export default createWebRegistrationFromManifest(
  googleWorkspaceWeb,
  {
    GoogleWorkspacePage: () => import('./GoogleWorkspacePage'),
  },
  {
    icons: { GoogleIcon },
  },
);
